/**
 * ValidationService is a service that handles validation errors in the application.
 * It provides methods to print and clear validation errors.
 * 
 * @module ValidationService
 */
export default {
  data() {
    return {
      /**
       * An object to store validation errors.
       * @type {Object}
       */
      validationErrors: {}
    };
  },

  methods: {
    /**
     * Prints validation errors from the response if the status is 422.
     * 
     * @param {Object} response - The response object containing validation errors.
     * @returns {void}
     */
    printValidationError(response) {
      if (!response || response.status !== 422) return;
      this.validationErrors = response.data.errors || {};
    },

    /**
     * Clears the validation errors and removes error elements from the DOM.
     * 
     * @returns {void}
     */
    clearValidationErrors() {

      this.validationErrors = {};
      const errorEls = document.querySelectorAll('.text-danger');
      errorEls.forEach(el => el.remove());
    },
  }
};
